var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1010.036 944.873l-265.309-265.309c55.855-69.818 93.091-162.909 93.091-260.655 0-232.727-186.182-418.909-418.909-418.909s-418.909 186.182-418.909 418.909 186.182 418.909 418.909 418.909c97.745 0 190.836-32.582 260.655-93.091l265.309 265.309c9.309 9.309 23.273 13.964 32.582 13.964s23.273-4.655 32.582-13.964c18.618-18.618 18.618-46.545 0-65.164zM93.091 418.909c0-181.527 144.291-325.818 325.818-325.818s325.818 144.291 325.818 325.818-144.291 325.818-325.818 325.818c-181.527 0-325.818-144.291-325.818-325.818z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fc68b4790bba43a628ca6b745ed97177.svg";
export { ForwardRef as ReactComponent };